import { render, staticRenderFns } from "./ExpandElement.vue?vue&type=template&id=1325e96e&scoped=true&"
import script from "./ExpandElement.vue?vue&type=script&lang=js&"
export * from "./ExpandElement.vue?vue&type=script&lang=js&"
import style0 from "./ExpandElement.vue?vue&type=style&index=0&id=1325e96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325e96e",
  null
  
)

export default component.exports